import React from "react";
import Profile from "../components/Profile/Profile";

const ProfilePage = () => {
  return (
    <div style={{ padding: "0", fontFamily: "Poppins" }}>
      <Profile />
    </div>
  );
};

export default ProfilePage;
